import { QuickViewUserCard } from '../../quick-view-user-card';
import type { UserPopoverUserProperties } from '../UserPopover';
import { UserPopoverContentWithQuery } from './user-popover-content-with-query';

type P = UserPopoverUserProperties;

const UserPopoverContent = (props: P) => {
  // TODO: refactor to not use `in props`
  if ('userId' in props) {
    const { fallback, userId } = props;
    return <UserPopoverContentWithQuery fallback={fallback} userId={userId} />;
  }

  const { user } = props;
  return <QuickViewUserCard isLoading={false} user={user} />;
};

export default UserPopoverContent;
